// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared styles for approved proof internal summary (project view + compact cards). */
.pq-proof-order-summary {
  border-top: 1px solid #e5e7eb;
  background: #fff;
  font-family: "Roboto", sans-serif;
}

.pq-proof-order-summary-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 16px 8px;
}

.pq-proof-order-summary-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  color: #374151;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.pq-proof-order-summary-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
}

.pq-proof-order-summary-hint {
  font-size: 11px;
  color: #9ca3af;
}

.pq-proof-order-summary-view-wrap {
  padding: 0 16px 14px;
}

.pq-proof-order-summary-view {
  position: relative;
  background: #fafafa;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 14px;
}

.pq-proof-order-summary-text {
  margin: 0;
  font-size: 14px;
  color: #111827;
  line-height: 1.6;
  white-space: pre-wrap;
}

.pq-proof-order-summary-edit-wrap {
  padding: 0 16px 14px;
}

.pq-proof-order-summary-textarea {
  width: 100%;
  min-height: 90px;
  padding: 12px 14px;
  border: 1.5px solid #d1d5db;
  border-radius: 8px;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  color: #111827;
  line-height: 1.6;
  resize: vertical;
  background: #fff;
  box-sizing: border-box;
}

.pq-proof-order-summary-textarea:focus {
  outline: none;
  border-color: #6b7280;
}

.pq-proof-order-summary-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.pq-proof-order-summary-foot-hint {
  font-size: 12px;
  color: #9ca3af;
}

.pq-proof-order-summary-actions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
}

.pq-proof-order-summary-cancel-btn {
  padding: 5px 12px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: #fff;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
}

.pq-proof-order-summary-cancel-btn:hover:not(:disabled) {
  background: #f9fafb;
}

.pq-proof-order-summary-save-btn {
  padding: 5px 14px;
  border-radius: 6px;
  border: none;
  background: #2563eb;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
}

.pq-proof-order-summary-save-btn:hover:not(:disabled) {
  background: #1d4ed8;
}

.pq-proof-order-summary-save-btn:disabled,
.pq-proof-order-summary-cancel-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.pq-proof-order-summary-edit-btn {
  position: absolute;
  top: 8px;
  right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/approved-proof-order-summary.css"],"names":[],"mappings":"AAAA,sFAAsF;AACtF;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ","sourcesContent":["/* Shared styles for approved proof internal summary (project view + compact cards). */\n.pq-proof-order-summary {\n  border-top: 1px solid #e5e7eb;\n  background: #fff;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.pq-proof-order-summary-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 16px 8px;\n}\n\n.pq-proof-order-summary-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #374151;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.pq-proof-order-summary-icon {\n  width: 16px;\n  height: 16px;\n  object-fit: contain;\n  flex-shrink: 0;\n  display: block;\n}\n\n.pq-proof-order-summary-hint {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n.pq-proof-order-summary-view-wrap {\n  padding: 0 16px 14px;\n}\n\n.pq-proof-order-summary-view {\n  position: relative;\n  background: #fafafa;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 12px 14px;\n}\n\n.pq-proof-order-summary-text {\n  margin: 0;\n  font-size: 14px;\n  color: #111827;\n  line-height: 1.6;\n  white-space: pre-wrap;\n}\n\n.pq-proof-order-summary-edit-wrap {\n  padding: 0 16px 14px;\n}\n\n.pq-proof-order-summary-textarea {\n  width: 100%;\n  min-height: 90px;\n  padding: 12px 14px;\n  border: 1.5px solid #d1d5db;\n  border-radius: 8px;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 14px;\n  color: #111827;\n  line-height: 1.6;\n  resize: vertical;\n  background: #fff;\n  box-sizing: border-box;\n}\n\n.pq-proof-order-summary-textarea:focus {\n  outline: none;\n  border-color: #6b7280;\n}\n\n.pq-proof-order-summary-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.pq-proof-order-summary-foot-hint {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.pq-proof-order-summary-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: auto;\n}\n\n.pq-proof-order-summary-cancel-btn {\n  padding: 5px 12px;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.pq-proof-order-summary-cancel-btn:hover:not(:disabled) {\n  background: #f9fafb;\n}\n\n.pq-proof-order-summary-save-btn {\n  padding: 5px 14px;\n  border-radius: 6px;\n  border: none;\n  background: #2563eb;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.pq-proof-order-summary-save-btn:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.pq-proof-order-summary-save-btn:disabled,\n.pq-proof-order-summary-cancel-btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.pq-proof-order-summary-edit-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
